type ENV = {
	AUTH0_BASE_URL?: string;
	AUTH0_CLIENT_ID?: string;
	AUTH0_RETURN_URL?: string;

	MAPBOX_PUBLIC_KEY?: string;
	YES_MAPBOX_PUBLIC_KEY_TOKEN?: string;

	DEV?: string;
	SSR?: string;
	MODE?: string;
	PROD?: string;
	BASE_URL?: string;
};

const testHostRegex = /^(localhost|test-lpoh\.livepower\.energy|172\.31\.38\.222)$/;

function getEnvConfig(): ENV {
	const isTestEnv = testHostRegex.test(window.location.hostname);
	const prefix = isTestEnv ? 'VITE_TEST_' : 'VITE_PROD_';

	const envConfig: ENV = {};

	Object.keys(import.meta.env).forEach(key => {
		if (key.startsWith(prefix)) {
			const cleanKey = key.substring(prefix.length);
			envConfig[cleanKey as keyof ENV] = import.meta.env[key];
		} else {
			envConfig[key as keyof ENV] = import.meta.env[key];
		}
	});

	return envConfig;
}

const ENV = getEnvConfig();

export default ENV;
